import Product from './Product'
import { Container, SubTitle, LabelRow } from './styles'

export default function ProductList ({ products = [] }) {
  if (products.length === 0) return (
    <Container>
      <SubTitle>
        0 resultados
      </SubTitle>
    </Container>
  )

  return (
    <Container>
      <SubTitle>
        {products.length + ' ' + (products.length === 1 ? 'Resultado' : 'Resultados')}
      </SubTitle>
      <LabelRow>
        <SubTitle>Nome</SubTitle>
        <SubTitle>Categoria</SubTitle>
        <SubTitle>Status</SubTitle>
      </LabelRow>
      {products.map (product => (
        <Product key={product.id} data={product}/>
      ))}
    </Container>
  )
}
